/* Custom variant dropdown: sold-out options are disabled and shown as "Name - Out Of Stock" (maroon).
   The theme's native <select> stays in the page (hidden) so cart/variant logic keeps working. */
(function () {
  if (window.__variantSoldOut) return;
  window.__variantSoldOut = true;

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  // Variants that haven't launched yet (e.g. "iPhone Duo") say COMING SOON instead of Out Of Stock.
  function outLabel(value, label) {
    return /duo/i.test(value) ? 'COMING SOON!' : label;
  }

  function closeAll(except) {
    document.querySelectorAll('.vs-custom.is-open').forEach(function (w) {
      if (w !== except) setOpen(w, false);
    });
  }

  function setOpen(wrap, open) {
    wrap.classList.toggle('is-open', open);
    var field = wrap.closest('.field');
    if (field) field.classList.toggle('vs-field-open', open);
    wrap.querySelector('.vs-trigger').setAttribute('aria-expanded', open ? 'true' : 'false');
    var list = wrap.querySelector('.vs-list');
    list.hidden = !open;
    if (open) {
      var cur = list.querySelector('.vs-item.is-selected') || list.querySelector('.vs-item:not(.is-unavailable)');
      if (cur) { cur.focus({ preventScroll: true }); cur.scrollIntoView({ block: 'nearest' }); }
    }
  }

  function choose(wrap, sel, value) {
    if (sel.value !== value) {
      sel.value = value;
      sel.dispatchEvent(new Event('input', { bubbles: true }));
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
    setOpen(wrap, false);
    wrap.querySelector('.vs-trigger').focus();
  }

  function enhance(sel, label) {
    var wrap = sel.__vsWrap;
    if (!wrap || !wrap.isConnected) {
      wrap = el('div', 'vs-custom');
      var trigger = el('button', 'vs-trigger');
      trigger.type = 'button';
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');
      var lbl = sel.id && document.querySelector('label[for="' + sel.id + '"]');
      if (lbl) trigger.setAttribute('aria-label', lbl.textContent.trim());
      var list = el('ul', 'vs-list');
      list.setAttribute('role', 'listbox');
      list.hidden = true;
      wrap.appendChild(trigger);
      wrap.appendChild(list);
      sel.classList.add('vs-native');
      sel.setAttribute('tabindex', '-1');
      sel.setAttribute('aria-hidden', 'true');
      sel.parentNode.insertBefore(wrap, sel);
      sel.__vsWrap = wrap;

      trigger.addEventListener('click', function () {
        var open = !wrap.classList.contains('is-open');
        closeAll(wrap);
        setOpen(wrap, open);
      });
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); closeAll(wrap); setOpen(wrap, true); }
      });
      list.addEventListener('click', function (e) {
        var item = e.target.closest('.vs-item');
        if (!item || item.classList.contains('is-unavailable')) return;
        choose(wrap, sel, item.getAttribute('data-value'));
      });
      list.addEventListener('keydown', function (e) {
        var items = Array.prototype.slice.call(list.querySelectorAll('.vs-item:not(.is-unavailable)'));
        var i = items.indexOf(document.activeElement);
        if (e.key === 'ArrowDown') { e.preventDefault(); (items[i + 1] || items[0]).focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); (items[i - 1] || items[items.length - 1]).focus(); }
        else if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          var a = document.activeElement;
          if (a && a.classList.contains('vs-item') && !a.classList.contains('is-unavailable')) choose(wrap, sel, a.getAttribute('data-value'));
        } else if (e.key === 'Escape' || e.key === 'Tab') { setOpen(wrap, false); trigger.focus(); }
      });
    }

    // Rebuild only when something changed (prevents observer loops)
    var sig = Array.prototype.map.call(sel.options, function (o) {
      return o.value + '|' + (o.classList.contains('is-unavailable') ? 0 : 1) + '|' + (o.selected ? 1 : 0);
    }).join('~');
    if (wrap.getAttribute('data-sig') === sig) return;
    wrap.setAttribute('data-sig', sig);

    var trig = wrap.querySelector('.vs-trigger');
    var ul = wrap.querySelector('.vs-list');
    trig.textContent = '';
    ul.textContent = '';
    Array.prototype.forEach.call(sel.options, function (o) {
      var out = o.classList.contains('is-unavailable');
      var li = el('li', 'vs-item' + (out ? ' is-unavailable' : '') + (o.selected ? ' is-selected' : ''));
      li.setAttribute('role', 'option');
      li.setAttribute('data-value', o.value);
      li.setAttribute('aria-selected', o.selected ? 'true' : 'false');
      if (out) li.setAttribute('aria-disabled', 'true');
      li.tabIndex = -1;
      li.appendChild(el('span', 'vs-name', o.value));
      if (out) li.appendChild(el('span', 'vs-soldout', ' - ' + outLabel(o.value, label)));
      ul.appendChild(li);
      if (o.selected) {
        trig.classList.toggle('is-unavailable', out);
        trig.appendChild(el('span', 'vs-name', o.value));
        if (out) trig.appendChild(el('span', 'vs-soldout', ' - ' + outLabel(o.value, label)));
      }
    });
  }

  function update(root) {
    var data = root.querySelector('script[data-variant-availability]');
    if (!data) return;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }
    var label = data.getAttribute('data-sold-out-label') || 'Out Of Stock';
    // Shopify only gives the theme the first 250 variants of a product. Products with more
    // (e.g. the Leather Sets) would otherwise show every later combination as Out Of Stock.
    var partialList = variants.length >= 250;
    var selects = Array.prototype.slice.call(root.querySelectorAll('.product-form__input--dropdown select'));
    if (!selects.length) return;
    var current = selects.map(function (s) { return s.value; });

    selects.forEach(function (sel, i) {
      Array.prototype.forEach.call(sel.options, function (opt) {
        var known = false;
        var ok = variants.some(function (v) {
          if (v.o[i] !== opt.value) return false;
          for (var j = 0; j < current.length; j++) {
            if (j !== i && v.o[j] !== current[j]) return false;
          }
          known = true;
          return !!v.a;
        });
        // Combination not in the (cut-off) list: don't guess, leave it selectable.
        if (!ok && !known && partialList) ok = true;
        if (opt.classList.contains('is-unavailable') !== !ok) opt.classList.toggle('is-unavailable', !ok);
        var dis = !ok && !opt.selected;
        if (opt.disabled !== dis) opt.disabled = dis;
        var text = ok ? opt.value : opt.value + ' - ' + outLabel(opt.value, label);
        if (opt.textContent !== text) opt.textContent = text;
      });
      enhance(sel, label);
    });
  }

  function updateAll() {
    document.querySelectorAll('variant-selects').forEach(update);
  }

  document.addEventListener('change', function (e) {
    var root = e.target && e.target.closest && e.target.closest('variant-selects');
    if (root) setTimeout(function () { update(root); }, 0);
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('.vs-custom')) closeAll(null);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });

  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; updateAll(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAll);
  } else {
    updateAll();
  }
})();
